module.exports = __webpack_public_path__ + "static/media/score.80042b16.svg";